import React, { useEffect, useState } from "react";
import Product from "../../../image/Product.svg";
import Pending from "../../../image/Pending.svg";
import Completed from "../../../image/Completed.svg";
import Collection from "../../../image/Collections.svg";
import LastCollection from "../../../image/LastCollection.svg";
import "./FormList.css";

const FormList = (props) => {
  const [innerlist, setinnerlist] = useState();
  const [pendinghai, setpendinghai] = useState(undefined);
  const [completed, setcompleted] = useState(undefined);
  const [lastmodified, setlastmodified] = useState(undefined);

  useEffect(() => {
    const callAplicationstatusapiinside = async (data) => {
      const response = await fetch(
        `http://localhost:5000/application/formid/${data}`,
        {
          method: "GET", // *GET, POST, PUT, DELETE, etc.
          mode: "cors", // no-cors, *cors, same-origin
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          // credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            //   'Content-Type': 'application/json',
            Authorization: process.env.REACT_APP_5000_BEARER_TOKEN,

            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: "follow", // manual, *follow, error
          referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          // body: JSON.stringify(data) // body data type must match "Content-Type" header
        }
      );

      let tempdata = await response.json();

      let completedcount = 0;
      let Rejectedcount = 0;

      console.log(tempdata)

      for (let i = 0; i < tempdata.applications.length; i++) {
        if (tempdata.applications[i].applicationStatus == "Completed") {
          completedcount++;
        }
      }

      for (let i = 0; i < tempdata.applications.length; i++) {
        if (tempdata.applications[i].applicationStatus == "Rejected") {
          Rejectedcount++;
        }
      }

      let totalcount = tempdata.totalCount;

      let pending = totalcount - completedcount - Rejectedcount;

      setpendinghai(pending);
      setcompleted(completedcount);
      setlastmodified(tempdata.applications[0].modified);
    };

    callAplicationstatusapiinside(props.id);
  }, [props.id]);

  function formatDate(string) {
    var options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  }

  return (
    <div className="container-fluid">
      <div className="card Card-Row">
        <div className="Card-Row-Boxes">
          <div className="Card-Box">
            <img src={Product} className="ProductImage" alt="ProductImage" />
            <div className="card-Box-headings">
              <span className="Card-Box-Head">Product</span>
              <h6 className="Card-Box-Head2">WEF</h6>
            </div>
          </div>

          <div className="Card-Box">
            <img src={Collection} className="ProductImage" alt="ProductImage" />
            <div className="card-Box-headings">
              <span className="Card-Box-Head">Collection</span>
              <h6 className="Card-Box-Head2">Weekly</h6>
            </div>
          </div>
          <div className="Card-Box">
            <img
              src={LastCollection}
              className="ProductImage"
              alt="ProductImage"
            />
            <div className="card-Box-headings">
              <span className="Card-Box-Head">Last Collected</span>
              <h6 className="Card-Box-Head2">
                {lastmodified != null ? formatDate(lastmodified) : "Never"}
              </h6>
            </div>
          </div>
          <div className="Card-Box">
            <img src={Pending} className="ProductImage" alt="ProductImage" />
            <div className="card-Box-headings">
              <span className="Card-Box-Head">Pending</span>
              <h6 className="Card-Box-Head2">
                {pendinghai != null ? pendinghai : "Never"}
              </h6>
            </div>
          </div>
          <div className="Card-Box">
            <img src={Completed} className="ProductImage" alt="ProductImage" />
            <div className="card-Box-headings">
              <span className="Card-Box-Head">Completed</span>
              <h6 className="Card-Box-Head2">
                {completed != null ? completed : "Never"}
              </h6>
            </div>
          </div>
        </div>
        <span className="Card_Data_Title">{props.data}</span>
      </div>
    </div>
  );
};

export default FormList;
